import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { signChallenge } from '@siteminder/authx-trusted-device-client'
import { getLocalUserDeviceToken } from '@/services/auth/authx-user-device-token'

const { useActions: useUserStoreActions } = createNamespacedHelpers('User')

/**
 * Runs the trusted device challenge round trip — request a challenge nonce,
 * sign it with the device's private key, and send the signature back for
 * verification. Returns the challengeId on success so the caller can pass it
 * along when redirecting back to the product.
 */
export const useVerifyTrustedDeviceChallenge = () => {

  const { getTrustedDeviceChallenge, verifyTrustedDeviceChallenge } = useUserStoreActions(['getTrustedDeviceChallenge', 'verifyTrustedDeviceChallenge'])

  const verify = async (deviceId: string, privateKey: CryptoKey, token: string): Promise<string> => {

    const challenge = await getTrustedDeviceChallenge({ deviceId, token })

    const signature = await signChallenge(privateKey, challenge.nonce)

    const userDeviceToken = getLocalUserDeviceToken()
    await verifyTrustedDeviceChallenge({
      deviceId,
      token,
      challengeId: challenge.challengeId,
      signature,
      userDeviceToken,
    })

    return challenge.challengeId

  }

  return { verify }

}
